module.exports = __webpack_public_path__ + "img/yxewm.dd4c19e7.jpg";